import { useReduxState } from 'hooks';
import { useFormState } from 'informed';
import { Badge } from 'components/common';
import {
  EmailMessageEditor,
  FormGroup,
  RadioGroup
} from 'components/common/form';

import type { EmailTemplateData } from 'shared-types';

interface Props {
  emailTemplates: EmailTemplateData[];
  newUsers: string[];
}

const AdminsAddNewUsers = ({ emailTemplates, newUsers }: Props) => {
  const { messages } = useReduxState();

  const formState = useFormState();

  return !newUsers.length || !emailTemplates ? null : (
    <>
      <FormGroup label={messages.commonNewUsers}>
        {newUsers.map((email) => (
          <Badge key={email} text={email} style={{ marginRight: 10 }} />
        ))}
      </FormGroup>

      <FormGroup label={messages.settingsAddAdminNewUsers}>
        <RadioGroup
          id="ignore-new-users"
          field="ignoreNewUsers"
          options={[
            {
              id: 'create',
              label: messages.settingsAddAdminNewUsersConfirm,
              value: false
            },
            {
              id: 'ignore',
              label: messages.settingsAddAdminNewUsersIgnore,
              value: true
            }
          ]}
        />
      </FormGroup>

      {formState.values.ignoreNewUsers ? null : (
        <EmailMessageEditor
          availableTemplates={emailTemplates}
          id="admins-add-new-users"
          style={{ marginTop: 20 }}
        />
      )}
    </>
  );
};

export default AdminsAddNewUsers;
